import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../../helpers/handleReportCalc';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  index: number;
}
const TBodyRow = ({ moduleData, isView, item, index }: IProps) => {
  const [render, setRender] = useState(false);
  const dataHandler = new ModuleDataHandler(moduleData);

  return (
    <>
      <tr>
        <td>
          {item?.customer_name ||
            (typeof item?.part_id !== 'string' &&
              item?.part_id?.customer_id.customer_name)}
        </td>
        <td>
          {item?.part_number ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_number)}
        </td>
        <td>
          {item?.part_name ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_name)}
        </td>

        <td>{item?.sale_rate}</td>

        {item?.qty_days_arr?.map((day: any, dayIdx: number) => (
          <td key={`${dayIdx}_dayindex`}>
            <TableInput
              key={`${dayIdx}_dayindex`}
              isView={isView}
              type="number"
              value={item.qty_days_arr[dayIdx] || null}
              onChange={(e) => {
                item.qty_days_arr[dayIdx] = Number(e.target.value);
                dataHandler.handleTotalDispatchAndSaleAmount(index);
                setRender((prev) => !prev);
              }}
            />
          </td>
        ))}
        <td>{item.total_dispatch}</td>
        <td>{item.sale_amount}</td>
      </tr>
    </>
  );
};

export default TBodyRow;
